// @ts-strict-ignore
import { PrebidAdapter } from '../prebid-adapter';
import { PrebidAdSlotConfig } from '../prebid-models';

export class YahooSsp extends PrebidAdapter {
	static bidderName = 'yahoossp';

	constructor(options) {
		super(options);
	}

	get bidderName(): string {
		return YahooSsp.bidderName;
	}

	prepareConfigForAdUnit(code, { sizes, pubId }: PrebidAdSlotConfig): PrebidAdUnit {
		const newSizes = this.filterSizesForRefreshing(code, sizes);
		return this.getStandardConfig(code, newSizes, pubId);
	}

	getStandardConfig(code, sizes, pubId): PrebidAdUnit {
		return {
			code,
			mediaTypes: {
				banner: {
					sizes,
				},
			},
			ortb2Imp: this.getOrtb2Imp(code),
			bids: this.getBids(pubId),
		};
	}

	getBids(pubId): PrebidBid[] {
		return pubId.map((id) => ({
			bidder: this.bidderName,
			params: {
				pubId: id,
			},
		}));
	}
}
